// Custom design cart upsell (snippets/artlines-custom-cart-upsell.liquid). Delegated at document level because the
// cart drawer re-renders its HTML after every change, and scripts inside re-rendered HTML don't run.
// Adds another custom item with the same design (default: a 2nd of the item they chose, same size/color): copies the source line's properties (Car Model, photo,
// _al_design_id) so the checkout Function charges catalog price (no second design fee).
(function () {
  if (window.__alCustomCartBound) return;
  window.__alCustomCartBound = true;

  // Currency: design fees and pack prices are stored in USD, product prices arrive converted. Recalculate offer
  // prices with Shopify's rate (the same rate the checkout Function uses) and format in the visitor's currency.
  const rate = () => Number(window.Shopify?.currency?.rate) || 1;
  const round = (value) => Math.round(value * 100) / 100;
  const money = (value) => {
    const amount = round(value);
    try {
      const whole = Number.isInteger(amount);
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return `$${amount.toFixed(2)}`;
    }
  };
  const formatPrices = (root = document) => {
    root.querySelectorAll('[data-al-money]').forEach((el) => {
      const price = Number(el.dataset.priceCents || 0) / 100;
      const fee = round(Number(el.dataset.fee || 0) * rate());
      const pack = round(Number(el.dataset.pack || 0) * rate());
      const addOn = Math.max(0, price - fee);
      let value;
      if (el.dataset.alMoney === 'addon') value = addOn;
      else if (el.dataset.alMoney === 'pack') value = pack;
      else if (el.dataset.alMoney === 'pack-saving') value = Number(el.dataset.qty || 0) * addOn - pack;
      else if (el.dataset.alMoney === 'pack-complete') value = pack - Number(el.dataset.have || 0) * addOn;
      if (value !== undefined) el.textContent = money(value);
    });
  };
  const run = () => formatPrices();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // The cart drawer re-renders its HTML after every change; format again whenever offers appear.
  new MutationObserver((mutations) => {
    if (mutations.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('[data-al-money]') || n.querySelector?.('[data-al-money]'))))) run();
  }).observe(document.documentElement, { childList: true, subtree: true });

  // "Change size or color": show the dropdowns, then point the Add button at the matching variant.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-al-offer-toggle]');
    if (!toggle) return;
    const options = toggle.closest('[data-al-offer]')?.querySelector('[data-al-offer-options]');
    if (options) options.hidden = !options.hidden;
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-al-offer-select]');
    if (!select) return;
    const offer = select.closest('[data-al-offer]');
    let variants = [];
    try {
      variants = JSON.parse(offer.querySelector('[data-al-offer-variants]').textContent);
    } catch (e) {}
    const chosen = [...offer.querySelectorAll('[data-al-offer-select]')].map((el) => el.value);
    const match = variants.find((v) => v.options.every((value, i) => value === chosen[i]));
    const button = offer.querySelector('[data-al-cart-add]');
    const label = offer.querySelector('[data-al-offer-variant]');
    if (match && match.available) {
      button.dataset.alCartAdd = match.id;
      button.disabled = false;
      button.textContent = 'Add';
      if (label) label.textContent = match.title;
    } else {
      button.disabled = true;
      button.textContent = 'Sold out';
      if (label) label.textContent = chosen.join(' / ');
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-al-cart-add]');
    if (!button) return;
    const root = button.closest('[data-al-cart-upsell]');
    let source = { properties: {} };
    try {
      source = JSON.parse(root.querySelector('[data-al-cart-source]').textContent);
    } catch (e) {}

    button.disabled = true;
    const originalLabel = button.innerHTML;
    button.textContent = 'Adding…';
    const drawer = document.querySelector('cart-drawer');
    const payload = {
      items: [
        {
          id: Number(button.dataset.alCartAdd),
          quantity: Math.max(1, Number(button.dataset.alCartQty || 1)),
          properties: {
            ...source.properties,
            'Custom design': 'Same design as your other items',
            _al_bundle_role: 'addon',
            _al_rec_surface: 'cart_drawer_custom_upsell',
          },
        },
      ],
    };
    if (drawer?.getSectionsToRender) {
      payload.sections = drawer.getSectionsToRender().map((section) => section.id).join(',');
      payload.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const json = await response.json();
      if (json.status) throw new Error(json.description || 'Could not add');
      if (drawer?.renderContents && json.sections) drawer.renderContents(json);
      else window.location.reload();
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.innerHTML = originalLabel;
    }
  });
})();
